// Single source for the brand maroon used across collapsible-header/boxed-
// summary UI (PermissionChecklist.jsx, LinkedDocumentsPanel.jsx,
// QuotationLinkedPanel.jsx, InfoTile.jsx) - keeps every caller in sync
// instead of re-hardcoding the hex value.
export const MAROON = "#6E1423";
export const MAROON_TINT = "#FBEAEC";
